import { getCategories, getQuestions } from '@/services/question';
import {
  CATEGORY_KEYS,
  COMMONAPP,
  COMMONAPP_VA,
  DATA_BACK_ON_QUESTION_KEY,
  DATA_BACK_ON_QUESTION_KEY_COMMONAPP,
  DATA_QUESTION_LAST,
  DATA_QUESTION_LAST_COMMONAPP,
  DATA_QUESTION_LAST_COMMONAPP_VA,
  DATA_QUESTION_MOVING_NEXT,
  DATA_QUESTION_MOVING_NEXT_COMMONAPP,
  DATA_QUESTION_MOVING_PREV,
  DATA_QUESTION_MOVING_PREV_COMMONAPP,
  DATA_QUESTION_REMOVE,
  DATA_QUESTION_REMOVE_COMMONAPP,
  DATA_QUESTION_REMOVE_COMMONAPP_VA,
  FORMAT_DATE,
  GENERATION_V3,
  KEYBOARD_TYPE,
  PLUS_NAME_FOR_OLD_QUOTE,
  QUESTION_KEY_HAS_OTHER_INPUT,
} from '@/utils/constants';
import {  DATA_BACK_ON_QUESTION_KEY_VERSION_3, DATA_QUESTION_MOVING_NEXT_VERSION_3, DATA_QUESTION_MOVING_PREV_VERSION_3, DATA_QUESTION_REMOVE_VERSION_3 } from '@/utils/flows/version_3';
import {
  ADDITIONAL_PERSON_CATEGORY,
  DEFAULT_CATEGORY_RECIPIENTS,
  OtherLabelText,
  QUESTIONS_KEY,
  REMOVE_RECIPIENT,
  SECONDARY_CARE,
  SUFFIX_QUESTION_KEY,
  SUFFIX_QUESTION_TEXT,
  UncertainLabelText,
  animalNamesConstant,
  getCurrentLocale,
  getFormatDate,
  transText,
  transfersInfo,
  transfersUnit,
  getDynamicAnswerValue,
} from '@/utils/utils';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useModel, useRequest, getLocale } from 'umi';
import { syncSameAsContacts } from '@/utils/contactRoles';

export default function useQuestionsModel() {
  const questionRef = useRef<HTMLDivElement>(null);

  const { client = {} as API.Client, isCommonApp, isMyHomeCareQuote, market, generation } = useModel('client');

  const [categories, setCategories] = useState<API.Category[]>([]);
  const [category, setCategory] = useState<API.Category>({} as API.Category);
  const recipient = useRef(DEFAULT_CATEGORY_RECIPIENTS);

  const [questions, setQuestions] = useState<API.Question[]>([]);
  const [current, setCurrent] = useState(0);
  const minCurrentIndex = useRef(0);
  const maxCurrentIndex = useRef(0);
  const [answers, setAnswers] = useState<{ [key: string]: any }>({});
  const [mainQuestion, setMainQuestion] = useState<API.Question[]>([]);
  const [totalProgess, setTotalProgess] = useState(0);
  const [currentProgess, setCurrentProgess] = useState(0);
  const [isUpdateReview, setIsUpdateReview] = useState(false)
  const focusQuestionKey = useRef("");
  const [autoCheckServices, setAutoCheckServices] = useState({
    '1st_recipient': {
      personalCare: false,
      companionCare: false
    },
    'full_care_2nd_recipient': {
      personalCare: false,
      companionCare: false
    },
    'minimal_care_2nd_recipient': {
      personalCare: false,
      companionCare: false
    },

  });
  const IadlServices = useRef<Record<string, boolean>>({
    '1st_recipient': false,
    'full_care_2nd_recipient': false,
    'minimal_care_2nd_recipient': false,
  }); 
  const isFillyourSeft =useRef(false);
 const careRecipientName = useRef<Record<string, string>>({
    '1st_recipient': '',
    'full_care_2nd_recipient': '',
    'minimal_care_2nd_recipient': '',
  }); 
  const [reloadKey, setReloadKey] = useState(false);
  const reloadForm = () => {
    setReloadKey(prev => !prev);
};
  const convertAnswerKey = (answerKey: string) => {
    return {
      qRecipient: answerKey.split('/')[0],
      qCategoryKey: answerKey.split('/')[1],
      qKey: answerKey.split('/')[2],
      optionKey: answerKey.split('/')[3],
    };
  };

    const [objectState, setObjectState] = useState({
      isLoading: false,
      isShowModalSaveDraft: false,
      relQuestionChoice: {
        isShow: false,
        option: null,
        isConfirm: true,
        question: null,
      },
      confirmHeightWeight: {
        isConfirm: false,
        isConfirmHeight: true,
        isConfirmWeight: true,
        isShowModal: false,
      },
      confirmOxygenSmoking: {
        isConfirm: false,
        isShowModal: false,
      },
      // HP-6: confirmedFor = the service address the respondent already confirmed (see utils/address.ts)
      confirmAddress: {
        isShowModal: false,
        confirmedFor: '',
      },
      // Shared confirmation suggestions (see utils/flows/suggestions.ts)
      activeSuggestionId: null,
      askedSuggestions: {},
      // Reassessment screen-level confirmation, keyed by screen id (see utils/reassessment.ts)
      reassessConfirm: {} as Record<string, 'yes' | 'no'>,
    });
    // Prior quote answers at reassessment, kept apart from the current answers (display only)
    const priorAnswers = useRef<Record<string, any>>({});

  const categoryQuestions = useMemo(
    () => {
      const allCategoryQuestions = questions.filter(
        (question) =>
          (question.category == category?.id || question.categories?.includes(category?.id || '')) &&
          question.name != 'Other'
      );

      // Remove question ADL
      if (!isUpdateReview && generation === GENERATION_V3 && !!IadlServices.current[recipient?.current]) {
        const iadlGroups = new Set(
          allCategoryQuestions
            .filter((question) =>
              question.choices.some((choice) => !!choice?.extraData?.iadl || !!choice?.iadl)
            )
            .map((question) => question.group)
        );

         return allCategoryQuestions.filter((question) => {
          if ([QUESTIONS_KEY.TRANSFER_ASSIST].includes(question.key)) {
            return false;
          }
          return !iadlGroups.has(question.group)
        })
      }

      return allCategoryQuestions;
    },
    [questions, category],
  );
  const groupQuestionsMaxIndex = (index: number) => {
    const arrayQuestion = categoryQuestions.filter(
      (question) => question?.group == categoryQuestions[index]?.group,
    );
    const result = categoryQuestions.findIndex(
      (question) => question?.key == arrayQuestion[arrayQuestion.length - 1]?.key,
    );
    return result === -1 ? 0 : result;
  };
  const groupQuestionsMinIndex = (index: number) => {
    const arrayQuestion = mainQuestion.length > 0 ? mainQuestion :  categoryQuestions.filter(
      (question) => question?.group === categoryQuestions[index]?.group,
    );
    const result = categoryQuestions.findIndex(
      (question) => question?.key === arrayQuestion[0]?.key,
    );
    return result === -1 ? 0 : result;
  };
  const currentQuestions = useMemo(() => {

    let questions = categoryQuestions.filter(
      (question) => question?.group == categoryQuestions[current]?.group,
    );
    questions = JSON.parse(JSON.stringify(questions));
    if (['callerName', 'fillerName'].includes(questions[0]?.key)) {
      const relationQuestion = categoryQuestions.filter(
        (question) => question?.key == 'relationship',
      );
      questions = [...questions, ...relationQuestion];
      if (recipient.current === DEFAULT_CATEGORY_RECIPIENTS) {
        const decisionMaker = categoryQuestions.filter(
          (question) => question?.key == 'decisionMaker',
        );
        questions = [...questions, ...decisionMaker];
      }

    }

    if (generation === GENERATION_V3 && questions[0]?.key === QUESTIONS_KEY.RECIPIENT_NAME) {
      if (getDynamicAnswerValue(answers, QUESTIONS_KEY.IS_STAFF) === "2"
        && recipient.current === DEFAULT_CATEGORY_RECIPIENTS) {
        const isRecipientDecisionMaker = categoryQuestions.filter(
          (question) => question?.key == 'isRecipientDecisionMaker',
        );
        questions = [...questions, ...isRecipientDecisionMaker];
      }
    }
    if(generation === GENERATION_V3 &&  "referralName" == questions[0]?.key){
       const decisionMaker = categoryQuestions.filter(
          (question) => question?.key == 'decisionMaker',
        );
        questions = [...questions, ...decisionMaker];
    }

    if (isCommonApp && questions[0]?.key === QUESTIONS_KEY.RECIPIENT_NAME) {
      if (getDynamicAnswerValue(answers, QUESTIONS_KEY.IS_STAFF) === "2" && current !== 0 && recipient.current === DEFAULT_CATEGORY_RECIPIENTS) {
        questions = questions.map((question) => {
          question.name = "Self/" + question.name;
          return question;
        })
      } else {
        questions = questions.map((question) => {
          if ([QUESTIONS_KEY.RECIPIENT_NAME, QUESTIONS_KEY.RECIPIENT_PHONE].includes(question.key)) {
            question.note = "";
          }
          return question;
        })
      }

    }
    return questions;
  }, [current, categoryQuestions]);
  const isLastQuestionOfCategory = useMemo(
    () =>
      !!categoryQuestions?.length &&
      (categoryQuestions[categoryQuestions?.length - 1]?.id ===
        categoryQuestions[maxCurrentIndex.current]?.id ||
        (DATA_QUESTION_LAST[category?.key] &&
          DATA_QUESTION_LAST[category?.key].includes(
            categoryQuestions[maxCurrentIndex.current]?.key,
          ))),
    [current],
  );

  const findQuestionIndexByKey = (questionKey: string, categoryParam?: API.Question[]) => {
    const cate = categoryParam || categoryQuestions;
    return cate.findIndex((q) => q?.key === questionKey);
  };

  const findCurrentCategoryIndex = () => categories?.findIndex((cate) => cate.id === category?.id);

  const getQuestionByKey = (qKey: string) =>
    questions.find((q) => q?.key === qKey) || ({} as API.Question);

  const getQuestionById = (id: string) =>
    questions.find((q) => q?.id === id) || ({} as API.Question);

  const findCategoryByKey = (key: string) =>
    categories?.find((c) => c?.key === key) || ({} as API.Category);

  const findQuestionChoiceByKey = (questionChoices: any, key: string) =>
    questionChoices?.find((c: any) => c?.key === key);
  const converFollowUpAnswer = (followUpQ: any, aValue: any, followUpAnswerKey?: string): any => {
    if (followUpQ.type === 'date' && aValue) {
      return moment(moment(aValue)).format(getFormatDate(market));
    }

    if (['radio', 'select_single', 'select_dropdown_single'].includes(followUpQ.type) && aValue) {
      const option = followUpQ?.options?.find((o: any) => o?.key === aValue);
      const otherText = followUpAnswerKey ? answers[`${followUpAnswerKey}Other`] : undefined;
      if ((option?.hasOther || aValue === 'OT') && otherText) {
        return `${option?.name}: ${otherText}`;
      }
      // @UN in dropdown/select single saves its explanation to "Uncertain"
      const uncertainText = followUpAnswerKey ? answers[`${followUpAnswerKey}Uncertain`] : undefined;
      if (aValue === '@UN' && uncertainText) {
        return `${option?.name}: ${uncertainText}`;
      }
      return option?.name;
    }

    if (['select_dropdown_multi', 'checkbox'].includes(followUpQ.type) && !!aValue && Array.isArray(aValue)) {
      // Multi-select has one shared "Other" input, opened by the first selected OT/hasOther option
      const explainKey = followUpQ?.options?.find((o: any) => aValue.includes(o?.key) && (o?.key === 'OT' || o?.hasOther))?.key;
      return "\n• " + aValue?.map((a: any) => {
        const choice = followUpQ?.options?.find((o: any) => o?.key === a);
        if(a === explainKey && answers[`${followUpAnswerKey}Other`]){
          return `${choice?.name}: ${answers[`${followUpAnswerKey}Other`]}`;
        }
        return choice?.name;
      })?.join("\n• ");
    }

    if ("datetime" === followUpQ.type && followUpAnswerKey) {
      return `${moment(moment(answers[followUpAnswerKey + 'date'], getFormatDate(market))).format(getFormatDate(market))} ${answers[followUpAnswerKey + 'time'] || ""
        }`
    }

    if ("address" === followUpQ.type && aValue) {
      return [aValue.street, aValue.unit, aValue.city, aValue.state, aValue.zipCode]
        .filter(Boolean)
        .join(', ');
    }
    return aValue;
  }
  const hasValue = (value:any) => {
    return !!value &&
      (
        (Array.isArray(value) && value.length > 0) ||
        (typeof value === "string" && value.trim() !== "") ||
        (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length > 0)
      );
  }
             
  const convertAnswer = (aKey: string, aValue: any) => {
    const { qKey, optionKey, qRecipient } = convertAnswerKey(aKey);
    let question = getQuestionByKey(qKey);
    let otherLabel = OtherLabelText();
    let answer: any[] = [];
    if (qKey === QUESTIONS_KEY.RECIPIENT_DOB_AGE) {
      //  question = getQuestionByKey(aKey.substring(0, aKey.search("Age")));
      question.name = "Age";
    }

    if (question?.keyboardType == KEYBOARD_TYPE.address) {
      answer = [
        [aValue.street, aValue.unit, aValue.city, aValue.state, aValue.zipCode]
          .filter(Boolean)
          .join(', '),
      ];
    } else if (question?.type === 'date' && aValue) {
      answer = [moment(moment(aValue)).format(getFormatDate(market))];
    } else if (question?.type === 'datetime') {
      if (answers[aKey + 'date']) {
        answer = [
          `${moment(moment(answers[aKey + 'date'], getFormatDate(market))).format(getFormatDate(market))} ${answers[aKey + 'time'] || ""
          }`,
        ];
      } else {
        answer = ['']
      }
    } else if (typeof aValue === 'object' && aValue?.[0]) {
      answer = aValue?.map((a = '') => {
        const choice = findQuestionChoiceByKey(question?.choices, a);
        let answerValue = choice?.name;
        if (choice?.hasOther && answers[`${aKey}Other/${choice?.key}`]) {
          if (question.key === QUESTIONS_KEY.TREATMENTS && answers[`${aKey}Other/${choice?.key}Other`]) {
            if (answers[`${aKey}Other/${choice?.key}Other`] == "OT") {
              answerValue = `${choice?.name}: ${answers[`${aKey}Other/${choice?.key}`]} - ${transText("app.label.other")}: ${answers[`${aKey}Other/${choice?.key}OtherOther`]}`
            }
            if (answers[`${aKey}Other/${choice?.key}Other`] == "@UN") {
              answerValue = `${choice?.name}: ${answers[`${aKey}Other/${choice?.key}`]} - ${transText("app.settings.uncertain")}: ${answers[`${aKey}Other/${choice?.key}OtherUncertain`]}`
            }
            answerValue = `${choice?.name}: ${answers[`${aKey}Other/${choice?.key}`]} - ${answers[`${aKey}Other/${choice?.key}Other`]}`
          }
          answerValue = `${choice?.name}: ${answers[`${aKey}Other/${choice?.key}`]}`;
        }
        if (SUFFIX_QUESTION_KEY[a] && answers[`${aKey}${SUFFIX_QUESTION_KEY[a]}`]) {

          answerValue = `${choice?.otherLabel || SUFFIX_QUESTION_TEXT[a]()}: ${answers[`${aKey}${SUFFIX_QUESTION_KEY[a]}`]}`;
        }

        if (generation === GENERATION_V3) {
          if ('select_chip_multi' === question.type) {
            if (choice?.followUpQuestionsExtraData && choice?.followUpQuestionsExtraData?.followUpQuestions) {
              choice?.followUpQuestionsExtraData?.followUpQuestions?.map((fq: any) => {
                if (hasValue(answers[`${aKey}followUpQ/${choice?.key}/${fq.id}`])) {
                  const followUpAnswer = converFollowUpAnswer(fq, answers[`${aKey}followUpQ/${choice?.key}/${fq.id}`],`${aKey}followUpQ/${choice?.key}/${fq.id}` )
                  if (!!followUpAnswer) {
                    answerValue = `${answerValue + "<span class='follow-up-answer'>" + (['select_dropdown_multi', 'checkbox'].includes(choice.type) ? " \n" : "\n • ") + fq.question + ": " + followUpAnswer + "</span>"}`
                  }
                }
              })
            }
          }
        }


        return answerValue
      });
    } else if (answers[`${aKey}Other`]) {
      const choice = findQuestionChoiceByKey(question?.choices, aValue);
      const hasOther = (!!choice?.hasOther || choice?.key == "OT") && !!choice?.otherLabel;
      if (hasOther) {
        answer = [choice?.name];
      }
      if(generation === GENERATION_V3 && QUESTION_KEY_HAS_OTHER_INPUT?.includes(question.key)){
         answer = [choice?.name];
      }
      // if (question.type === 'select_chip_single') {
      otherLabel = hasOther ? `${choice?.otherLabel}` : otherLabel;
      //}
      if (question.key == QUESTIONS_KEY.COMPANION_SITTERALL) {
        answer = [choice?.name];
        otherLabel = "";
      }
      answer = [...answer, `${otherLabel}: ${answers[`${aKey}Other`]}`];
    } else if (answers[`${aKey}Uncertain`]) {
      answer = [`${UncertainLabelText()}: ${answers[`${aKey}Uncertain`]}`];
    } else if (findQuestionChoiceByKey(question?.choices, aValue)) {
      answer = [...answer, findQuestionChoiceByKey(question?.choices, aValue)?.name];
    } else {
      answer = [aValue];
    }
    if (answers[`${aKey}${PLUS_NAME_FOR_OLD_QUOTE}`]) {
      answer = [...answer, `${answers[`${aKey}${PLUS_NAME_FOR_OLD_QUOTE}`]}`];
    }

    if (question.key === QUESTIONS_KEY.PET_CARE && aValue && aValue != "OT") {
      if (['2', '3'].includes(aValue)) {
        answer = [`${findQuestionChoiceByKey(question?.choices, aValue)?.name}:`, answers[`${aKey}Other`]];
      } else {
        const locale = getLocale().split('-')[0];
        let otherAnswer: string[] = [];
        const selectChoice = question?.choices.find((choice) => answers[aKey] == choice.key);
        const animalNames = selectChoice?.extraData?.otherLable || animalNamesConstant[locale];
        animalNames.map((name: any) => {
          if (answers[`${aKey}Other/${name}`]) {
            otherAnswer.push(`${name}: ${answers[`${aKey}Other/${name}`]}`);
          }
        }
        );
        answer = [`${findQuestionChoiceByKey(question?.choices, aValue)?.name}`, otherAnswer.join(", ")]
      }
    }

    if ([QUESTIONS_KEY.BATHING, QUESTIONS_KEY.NUTRITION].includes(question.key)) {
      if (answers[`${aKey}OtherKey`]) {
        let otherAnswers = answers[`${aKey}OtherKey`];
        if (otherAnswers.includes("OT")) {
          otherAnswers = otherAnswers.map((answer: string) => answer === "OT" ? `Other: ${answers[`${aKey}OtherKeyOther`]}` : answer)
        }
        answer = [answer + ": " + otherAnswers.join(", ")]
      }
    }
    if (question.key === QUESTIONS_KEY.TRANSFERS && aValue) {

      let otherAnswer: string[] = [];
      transfersInfo.map((name) => {
        if (answers[`${aKey}Other/${name}`]) {
          if (name === "select") {
            otherAnswer.push(answers[`${aKey}Other/${name}`])
          }
          else otherAnswer.push(`${name}: ${answers[`${aKey}Other/${name}`]} ${transfersUnit[name]}`);
        }
      }
      );
      answer = [`${findQuestionChoiceByKey(question?.choices, aValue)?.name}`, otherAnswer.join(", ")]
    }
    if (isCommonApp) {
      if (question.key === QUESTIONS_KEY.CONTACT_TIME_DATE) {
        answer = [`${transText("app.label.name")}: ${answers[aKey + 'name']}, ${transText("app.label.phone")}: ${answers[aKey + 'phone']}, ${transText("app.label.email")}: ${answers[aKey + 'email']}, ${transText("app.label.contact_me_on_date")}: ${moment(moment(answers[aKey + 'date'], FORMAT_DATE)).format(FORMAT_DATE)} ${answers[aKey + 'time']} ${answers[aKey + 'timeZone']}`];
      }
      if (question.key === QUESTIONS_KEY.RELATIONSHIP) {

        if (answers[`${aKey}OtherKey`]) {
          let otherAnswers = answers[`${aKey}OtherKey`];
          if (otherAnswers === "OT") {
            otherAnswers = "Other" + ":" + answers[`${aKey}OtherKeyOther`]
          }
          answer = [answer + ": " + otherAnswers]
        }
      }
    }

    if (generation === GENERATION_V3) {
      if (['select_chip_single', 'radio', 'select_dropdown'].includes(question?.type)) {
        const choice = findQuestionChoiceByKey(question?.choices, aValue);
        if (choice?.followUpQuestionsExtraData && choice?.followUpQuestionsExtraData?.followUpQuestions) {
          choice?.followUpQuestionsExtraData?.followUpQuestions?.map((fq: any) => {
            if (hasValue(answers[`${aKey}followUpQ/${fq.id}`])) {
              const followUpAnswer = converFollowUpAnswer(fq, answers[`${aKey}followUpQ/${fq.id}`],`${aKey}followUpQ/${fq.id}` )
              answer = [answer + "<span class='follow-up-answer'>" + (['select_dropdown_multi', 'checkbox'].includes(fq?.type) ? " \n" : "\n • ") + fq.question + ": " + followUpAnswer + '</span>']
            }
          })
        }
      }
      // Replace Recipient name 
      if (['primaryEmergencyContact', 'medicalDecisionMaker', 'primaryCoordinator', 'financialDecisionMaker', 'daysRequiredService', "hoursNeededPreferred", "servicesProvided"].includes(question?.key)) {
       
        answer.forEach((originalText, index) => {
          let values = Array.isArray(aValue) ? aValue : [aValue];
           let newText = originalText;
          values.forEach((value: string) => {
          switch (value) {
            case 'yes_decision_maker':
                newText = newText.replace('[name]', getDynamicAnswerValue(answers, `decision_maker_name`));
              break;
            case 'yes_medical_poa':
                newText = newText.replace('[name]', getDynamicAnswerValue(answers, `medical_poa_name`, qRecipient));
              break;
            case 'yes_financial_poa':
                newText = newText.replace('[name]', getDynamicAnswerValue(answers, `financial_poa_name`, qRecipient));
              break;
            case 'yes_coordinator':
                newText = newText.replace('[name]', getDynamicAnswerValue(answers, `coordinator_name`, qRecipient));
              break;
            case "sameFirstPerson":
              const p1Name = careRecipientName.current['1st_recipient']?.trim() || "Person 1";
                newText = newText.replace('[person1_name]', p1Name);
                break;
            default: break;
            }
          })
          answer[index] = newText
          }
        )
      }

      // Add personal care for Service question
      if(question.key === QUESTIONS_KEY.COMPANION_SITTERALL) {
        let displayPersonalCare = false; 
        
        if(getDynamicAnswerValue(answers,'companion_hands_on_help') === "yes_personal_care"){
          displayPersonalCare = true;
        }

        if(getDynamicAnswerValue(answers,'strm_service_type') === "personal_care_adl"){
          displayPersonalCare = true;
        }
      
        if(displayPersonalCare) {
          const personalCareChoice = findQuestionChoiceByKey(question?.choices, "2");
          answer = [ ...answer,personalCareChoice?.name ]
        }
      }
    }


    return {
      question,
      isCare2ND: SECONDARY_CARE.includes(qRecipient) || false,
      answer,
      optionKey,
    };
  };

  const getCategoryQuestions = useCallback(
    (categoryId?: string) => {
      const allCategoryQuestions = questions.filter(
        (question) =>
          (question.category == categoryId || question.categories?.includes(categoryId || '')) &&
          question.name != 'Other'
      );

      // Remove question ADL
      if (!isUpdateReview && generation === GENERATION_V3 && !!IadlServices.current[recipient?.current]) {
        const iadlGroups = new Set(
          allCategoryQuestions
            .filter((question) =>
              question.choices.some((choice) => !!choice?.extraData?.iadl || !!choice?.iadl)
            )
            .map((question) => question.group)
        );
        
        return allCategoryQuestions.filter((question) => {
          if ([QUESTIONS_KEY.TRANSFER_ASSIST].includes(question.key)) {
            return false;
          }
          return !iadlGroups.has(question.group)
        }
        );
      }

      return allCategoryQuestions;
    },
    [questions, category, isUpdateReview],
  );

  const removeAllAnswersByRecipient = (recips: string[], answersParam?: any) => {
    const newAnswers = recips.reduce((prevAnswer, recip) => {
      return Object.keys(prevAnswer)
        .filter((aKey) => {
          const { qRecipient } = convertAnswerKey(aKey);
          return qRecipient !== recip;
        })
        .reduce((prev, cur) => {
          prev[cur] = answersParam[cur];
          return prev;
        }, {});
    }, answersParam || answers);
    setAnswers(newAnswers);
  };

  const onChangeCategory = (cate: API.Category) => {
    setCategory(cate);
    recipient.current = getRecipientByCategory(cate);
    setMainQuestion([]);
    setCurrent(0);
    // maxCurrentIndex.current = 0;
    // minCurrentIndex.current = 0;
  };

  const removeListAnswerByQuestionKey = (removeQuestionKey: string[]) => {

    if (removeQuestionKey?.length) {

      const newAnswers = answers;
      const answerKeys = Object.keys(newAnswers);
      removeQuestionKey.forEach((questionKey: string) => {
        delete newAnswers[`${recipient.current}/${category?.key}/${questionKey}`];
        if (generation === GENERATION_V3) {
          answerKeys.forEach((answerKey) => {
          if (answerKey.includes(`${questionKey}followUpQ`)) {
            delete newAnswers[answerKey];
          }
          })
        }
      });

      return newAnswers;
    }
    return answers;
  };

  const removeAnswersByChangeQuestionThread = (
    qKey: string,
    aKey: string,
    currentAnswers = answers,
  ) => {
    if (isCommonApp) {
      const dataQuestionRemoveCommonApp = isMyHomeCareQuote ? DATA_QUESTION_REMOVE_COMMONAPP : DATA_QUESTION_REMOVE_COMMONAPP_VA;
      if (dataQuestionRemoveCommonApp[qKey] && dataQuestionRemoveCommonApp[qKey][`${aKey}`]) {
        const removeQuestionKey = dataQuestionRemoveCommonApp[qKey][`${aKey}`];
        return removeListAnswerByQuestionKey(removeQuestionKey);
      }
    }

    if (generation === GENERATION_V3) {
      if (DATA_QUESTION_REMOVE_VERSION_3[qKey] && DATA_QUESTION_REMOVE_VERSION_3[qKey][`${aKey}`]) {
        const removeQuestionKey = DATA_QUESTION_REMOVE_VERSION_3[qKey][`${aKey}`];
        return removeListAnswerByQuestionKey(removeQuestionKey);
      }
    } else {
      if (DATA_QUESTION_REMOVE[qKey] && DATA_QUESTION_REMOVE[qKey][`${aKey}`]) {
        const removeQuestionKey = DATA_QUESTION_REMOVE[qKey][`${aKey}`];
        return removeListAnswerByQuestionKey(removeQuestionKey);
      }
    }

    return currentAnswers;
  };

  const nextCategory = (listCategories = categories) => {
    const currentIndex = listCategories?.findIndex((c) => c.id === category?.id) || 0;
    const nextCate = listCategories?.length ? listCategories[currentIndex + 1] : category;
    setCategory(nextCate);
  };

  const backCategory = () => {
    const currentIndex = categories?.findIndex((c) => c.id === category?.id) || 0;
    if (currentIndex !== 0) {
      const cateBack = categories?.length ? categories[currentIndex - 1] : category;
      setCategory(cateBack);
      recipient.current = getRecipientByCategory(cateBack);
      const backIndex = getCategoryQuestions(cateBack?.id).length - 1;
      if (isMyHomeCareQuote && cateBack.key == CATEGORY_KEYS[generation].additional_notes) {
        setCurrent(backIndex - 1);
        return cateBack;
      }
      setCurrent(backIndex);
      // maxCurrentIndex.current = backIndex;
      // minCurrentIndex.current = groupQuestionsMinIndex(backIndex);
      return cateBack;
    }
  };

  const getNextNormalNextQuestion = () => {
    if (categoryQuestions.length - 1 == maxCurrentIndex.current) {
      nextCategory();
      return 0;
    } else {
      return maxCurrentIndex.current + 1;
    }
  };

  const getNextQuestion = (
    answerKey: string,
    answerRecipient: string,
    answerValue: string,
    inputAnswers?: any,
  ) => {
    const newAnswers = inputAnswers || answers;
    let nextQuestionKey = '';
    if (generation == GENERATION_V3) {

      nextQuestionKey = DATA_QUESTION_MOVING_NEXT_VERSION_3[recipient.current]?.[`${answerKey}`];
    } else {
      if (isCommonApp) {

        const dataQuestionLastCommonApp = client?.appType === COMMONAPP_VA ? DATA_QUESTION_LAST_COMMONAPP_VA : DATA_QUESTION_LAST_COMMONAPP;

        if (
          dataQuestionLastCommonApp[category?.key] &&
          dataQuestionLastCommonApp[category?.key].includes(answerKey)
        ) {
          nextCategory();
          return 0;
        }

        if (answerKey == QUESTIONS_KEY.ADDITIONAL_PERSON) {
          if (answerValue != '0') {
            nextCategory();
            return 0;
          } else {
            return getNextNormalNextQuestion();
          }
        }
      }

      if (!isCommonApp &&
        DATA_QUESTION_LAST[category?.key] &&
        DATA_QUESTION_LAST[category?.key].includes(answerKey)
      ) {
        nextCategory();
        return 0;
      }

      nextQuestionKey = DATA_QUESTION_MOVING_NEXT[`${answerKey}`];
      if (isCommonApp) {
        nextQuestionKey = DATA_QUESTION_MOVING_NEXT_COMMONAPP[`${answerKey}`];
      }
    }

    if (!nextQuestionKey) {
      return getNextNormalNextQuestion();
    }

    // Conditional rules (array of { condition, nextKey }) — kept for legacy flows
    if (nextQuestionKey && typeof nextQuestionKey == 'object' && nextQuestionKey[0]) {
      const nextQuestion = nextQuestionKey.find((item: any) => {
        const { condition } = item;
        const isVerifiedAllCondition = Object.keys(condition).every((ck) =>
          Object.keys(newAnswers).some((ak) => {
            const answer = newAnswers[ak];
            const { qKey, qRecipient } = convertAnswerKey(ak);
            const isVerified =
              (ck === qKey && condition[ck] == answer && answerRecipient === qRecipient) ||
              (ck === answerKey && condition[ck] == answerValue && answerRecipient === qRecipient);
            return isVerified;
          }),
        );
        return isVerifiedAllCondition;
      });

      if (nextQuestion) {
        if (isCommonApp && nextQuestion.nextKey === QUESTIONS_KEY.ADDITIONAL_NOTES) {
          nextCategory();
          return 0;
        }
        const index = categoryQuestions.findIndex((c) => c?.key === nextQuestion?.nextKey);
        return index === -1 ? getNextNormalNextQuestion() : index;
      } else {
        return getNextNormalNextQuestion();
      }
    }

    // String nextQuestionKey — try same category first, then cross-category jump
    if (nextQuestionKey) {
      const index = categoryQuestions.findIndex((c) => c?.key === nextQuestionKey);
      if (index !== -1) return index;



      return getNextNormalNextQuestion();
    }

    return getNextNormalNextQuestion();
  };

  const getTotalProgess = () => {
    const totalQuestion: any = categories
      ?.map((cate) => getCategoryQuestions(cate.id))
      .concat()
      .flat();
    setTotalProgess(totalQuestion?.length || 0);
  };

  const getCurrentProgess = () => {
    const currentCategoryIndex = findCurrentCategoryIndex();
    const completedCategory = categories?.slice(0, currentCategoryIndex);
    const totalLength = completedCategory?.reduce((total, cate) => {
      return total + getCategoryQuestions(cate?.id).length;
    }, 0);
    if (currentCategoryIndex !== -1) {
      setCurrentProgess(totalLength! + maxCurrentIndex.current + 1 || 0);
    }
  };

  const getBackNormalBackQuestion = () => {
    if (minCurrentIndex.current === 0) {
      const cateBack = backCategory();
      const lisQuestionsCate = getCategoryQuestions(cateBack?.id);
      return lisQuestionsCate?.length - 1;
    } else {
      return minCurrentIndex.current - 1;
    }
  };

  const findQuestionIndexByBackKey = (backQuestionKey: any, cateId?: string) => {

    if (!backQuestionKey) {
      return getBackNormalBackQuestion();
    } else {
      const answerKeys = Object.keys(answers);
      const answer = answerKeys.find((ak) => {
        const { qKey } = convertAnswerKey(ak);
        return qKey === backQuestionKey;
      });
      if (answer) {
        const { qKey } = convertAnswerKey(answer);
        return findQuestionIndexByKey(qKey, cateId ? getCategoryQuestions(cateId) : undefined);
      } else if (typeof backQuestionKey === 'string') {
        return getBackNormalBackQuestion();

      } else {
        const backQuestion = backQuestionKey.find((b: any) => {
          const { condition } = b;
          return answerKeys.find((ak) => {
            const ans = answers[ak];
            const { qKey } = convertAnswerKey(ak);
            if (condition[qKey] && ans === condition[qKey]) {
              return true;
            }
          });
        });

        if (!backQuestion) return getBackNormalBackQuestion();
        const backIndex = findQuestionIndexByKey(
          backQuestion?.backKey,
          cateId ? getCategoryQuestions(cateId) : undefined,
        );
        return (backIndex || backIndex === 0) && backIndex !== -1
          ? backIndex
          : getBackNormalBackQuestion();
      }
    }
  };

  const onBackQuestion = () => {
    let backQuestionKey: any;

    if (generation == GENERATION_V3) {
      backQuestionKey = DATA_QUESTION_MOVING_PREV_VERSION_3 &&
        DATA_QUESTION_MOVING_PREV_VERSION_3?.[recipient.current]?.[
        `${categoryQuestions[minCurrentIndex.current]?.key}`
        ];
    } else {
      backQuestionKey =
        DATA_QUESTION_MOVING_PREV &&
        DATA_QUESTION_MOVING_PREV?.[recipient.current]?.[
        `${categoryQuestions[minCurrentIndex.current]?.key}`
        ];
      if (isCommonApp) {
        backQuestionKey = DATA_QUESTION_MOVING_PREV_COMMONAPP &&
          DATA_QUESTION_MOVING_PREV_COMMONAPP?.[recipient.current]?.[
          `${categoryQuestions[minCurrentIndex.current]?.key}`
          ];
      }
    }
    if (minCurrentIndex.current === 0 && !backQuestionKey) {
      backCategory();
    } else if (minCurrentIndex.current === 0 && backQuestionKey) {
      const backCate = backCategory();
      const backIndex = findQuestionIndexByBackKey(backQuestionKey, backCate?.id);
      setCurrent(backIndex);
    } else {
      const backIndex = findQuestionIndexByBackKey(backQuestionKey);
      setCurrent(backIndex);
    }
  };
  const removeAnswersByChangeQuestion = (answer: any, currentAnswers = answers,) => {
    const answerKeys = Object.keys(answer);
    const currentAnswersKeys = Object.keys(currentAnswers)
    answerKeys.forEach((answerKey) => {
      if (currentAnswers[answerKey] && currentAnswers[answerKey] !== answer[answerKey]) {
        currentAnswersKeys.forEach((currentAnswersKey) => {
          if (currentAnswersKey.includes(answerKey)) {
            delete currentAnswers[currentAnswersKey];
          }
        });
        if (generation === GENERATION_V3) {
          if (answerKey.includes('followUpQ')) {
            const parts = answerKey.split('/');
            if (parts.length >= 3) {
              const baseFollowUpKey = `${parts[0]}/${parts[1]}/${parts[2]}`;
              currentAnswersKeys.forEach((currentKey) => {
                if (currentKey.startsWith(baseFollowUpKey)) {
                  if (!answerKeys.includes(currentKey)) {
                    delete currentAnswers[currentKey];
                  }
                }
              });
            }
          }
        }
      }
    });



    return currentAnswers;
  };
  const addAnswerTo2ndPerson = (currentAnswers = answers) => {
    const fullCareAnswer = {};
    const answerKeys = Object.keys(currentAnswers);
    answerKeys.map((key) => {
      if (key.includes(ADDITIONAL_PERSON_CATEGORY[2]) &&
        key.split('/')?.[2] !== QUESTIONS_KEY.DAYS_REQUIRED_SERVICE
      ) {
        const answerKey = key.replace(ADDITIONAL_PERSON_CATEGORY[2], ADDITIONAL_PERSON_CATEGORY[3]).replace(CATEGORY_KEYS?.[generation]?.minimalPotentialClientIntake, CATEGORY_KEYS?.[generation]?.potentialClientIntake)
        fullCareAnswer[answerKey] = currentAnswers[key]
      }
    })
    return fullCareAnswer
  };
  const autoFillADLQuestionsAnswer = (currentAnswers = answers, isADL: boolean) => {
    questions.forEach((q: API.Question) => {
      q.choices.forEach((choice) => {

        if ((!!choice?.extraData?.iadl || !!choice?.iadl)) {
          if (isADL) {
            currentAnswers[`${recipient.current}/${category?.key}/${q.key}`] = choice.key;
          } else {
            if (!!currentAnswers[`${recipient.current}/${category?.key}/${q.key}`]) {
              delete currentAnswers[`${recipient.current}/${category?.key}/${q.key}`];
            }
          }
        }
      });
    })
    return currentAnswers;
  }
  const onNextQuestion = (answer: any, currentAnswers = answers) => {
    const answerKeys = Object.keys(answer);
    let answerKey = answerKeys?.slice(-1)[0] + '';
    const answerValue = answer[answerKey];
    const { qKey, qRecipient, qCategoryKey } = convertAnswerKey(answerKey);

    let newAnswers = currentAnswers;
    let nextQuestionKey = qKey
     .replace(/CheckboxOther$/, '')
      .replace(/followUpQ$/, '')
      .replace(/Other$/, '');
    let nextQuestionIndex = categoryQuestions.findIndex((q) => q.key === nextQuestionKey);
     
    answerKeys.map((key) => {
      const a = convertAnswerKey(key);
      newAnswers = removeAnswersByChangeQuestionThread(a.qKey, answer[key], currentAnswers);

      if ([QUESTIONS_KEY.COMPANION_SITTERALL, QUESTIONS_KEY.COMPANION_SITTERALL_OTHER].includes(a.qKey)) {
        const servicesAnswer = answer[`${recipient.current}/${category?.key}/${QUESTIONS_KEY.COMPANION_SITTERALL}`];
        let disable = false;
        if (servicesAnswer == "1") {
             disable = true;

         
        }

        if (servicesAnswer == "strm") {
          const otherInputAnswer = answer[`${recipient.current}/${category?.key}/${QUESTIONS_KEY.COMPANION_SITTERALL}Other`]
          if (otherInputAnswer?.includes("Companion/Sitter")) {
            disable = true;
          }
        }

        if (generation === GENERATION_V3) {
          disable = false;
          const companionAnswer = answer[`${recipient.current}/${category?.key}/${QUESTIONS_KEY.COMPANION_SITTERALL}followUpQ/companion_hands_on_help`];
          if (companionAnswer === 'no_companionship') {
            disable = true;
          }

          }
        IadlServices.current[recipient?.current] = disable;
        newAnswers = autoFillADLQuestionsAnswer(newAnswers, disable);
      }

      if (generation === GENERATION_V3) {
        if (a.qKey === QUESTIONS_KEY.RECIPIENT_NAME) {
          if (careRecipientName.current[recipient?.current] !== undefined) {
            careRecipientName.current[recipient?.current] = answer[key]
          }
        }
      }
      if (!isCommonApp && a.qKey === QUESTIONS_KEY.IS_STAFF) {
        if (answer[key] === "2") {
          isFillyourSeft.current = true;
        } else {
          isFillyourSeft.current = false;
        }
      }
      const qIndex = categoryQuestions.findIndex((q) => q.key === a.qKey);
      if (qIndex > nextQuestionIndex) {
        nextQuestionIndex = qIndex
        nextQuestionKey = a.qKey
      }
    })
    newAnswers = removeAnswersByChangeQuestion(answer, newAnswers);
    newAnswers = {
      ...currentAnswers,
      ...answer,

    };
    if (generation === GENERATION_V3) {
      // TRM 6.5: "Same as [name]" roles follow changes to the contact they were copied from
      newAnswers = syncSameAsContacts(newAnswers, { backfill: true });
    }
    setAnswers(newAnswers);
    // console.log('nextQuestionKey', nextQuestionKey)

    const nextIndex = getNextQuestion(nextQuestionKey, qRecipient, answerValue, newAnswers);
    setCurrent(nextIndex);
    // maxCurrentIndex.current = groupQuestionsMaxIndex(nextIndex);
    // minCurrentIndex.current = groupQuestionsMinIndex(nextIndex);
    questionRef?.current?.scroll(0, 0);

    return newAnswers;
  };

  const { run: fetchCategories } = useRequest(
    ({
      recipients,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      values,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      nextCate,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isPrimaryQuote,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isSibling,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      callBack,
    }: {
      recipients?: any;
      values?: any;
      nextCate?: boolean;
      isPrimaryQuote?: boolean;
      isSibling?: boolean;
      callBack?: any;
    }): Promise<API.Category[]> => getCategories(recipients, generation),
    {
      cacheKey: 'categories',
      manual: true,
      formatResult: (res) => res,
      onSuccess: (
        data,
        [
          {
            recipients,
            values,
            nextCate = true,
            isPrimaryQuote = true,
            isSibling,
            callBack = () => { },
          },
        ],
      ) => {
        let newCategories = data;
        if (!isPrimaryQuote && isSibling) {
          newCategories = data.filter(
            (r: API.Category) => r?.name?.includes('(2)') || r?.key === CATEGORY_KEYS?.[generation]?.['review'],
          );
          const first2ndCategory = newCategories.find((c: API.Category) =>
            c?.name?.includes('(2)'),
          );
          //  setCategory(first2ndCategory);
        }
        setCategories(newCategories || []);

        if (newCategories.length) {

          if (recipients) {

            const newAnswers = values ? onNextQuestion(values) : answers;
            if (isMyHomeCareQuote && recipients == DEFAULT_CATEGORY_RECIPIENTS && currentQuestions?.[0]?.key == "anyAdditionalPerson") {
              if (!!REMOVE_RECIPIENT[`${recipients}`]) {
                removeAllAnswersByRecipient(REMOVE_RECIPIENT[`${recipients}`], newAnswers);
              }
              return;
            }
            if (nextCate) {
              recipient.current = recipients;
              nextCategory(newCategories);
            }
            setCurrent(0);
            // maxCurrentIndex.current = 0;
            // minCurrentIndex.current = 0;
            if (!!REMOVE_RECIPIENT[`${recipients}`]) {
              removeAllAnswersByRecipient(REMOVE_RECIPIENT[`${recipients}`], newAnswers);
            }
          } else {
            setCategory(newCategories[0]);
            setCurrent(0);
            // maxCurrentIndex.current = 0;
            // minCurrentIndex.current = 0;
          }
        }
        callBack(newCategories);
      },
    },
  );

  const { loading, run: fetchQuestions } = useRequest(
    (): Promise<API.Question[]> => getQuestions(client?.appType),
    {
      cacheKey: 'questions',
      manual: true,
      formatResult: (res) => res,
      onSuccess: (data) => {
        if (isCommonApp) {
          const newQuestions = data.filter((question: API.Question) => {
            return question.key !== QUESTIONS_KEY.ALLOW_CONTACT
          })
          setQuestions(newQuestions);
        } else setQuestions(data);
      },
    },
  );

  const filterAnswers = (ans: any) => {
    const answersFilter = {};
    Object.entries(ans).filter(([key, value]) => {
      const { qKey } = convertAnswerKey(key);
      if (key && !qKey?.includes('Uncertain') && !qKey?.includes('Other')) {
        answersFilter[key] = value;
      }
    });
    return answersFilter;
  };

  const sortAnswers = (ans: any) => {
    return Object.keys(ans)
      .sort((prevKey: string, curKey: string) => {
        const { qCategoryKey: prevCategoryKey, qKey: prevQkey } = convertAnswerKey(prevKey);
        const { qCategoryKey: curCategoryKey, qKey: curQkey } = convertAnswerKey(curKey);
        const prevCategory = findCategoryByKey(prevCategoryKey);
        const curCategory = findCategoryByKey(curCategoryKey);
        if (prevCategory?.position != curCategory?.position) {
          return prevCategory?.position - curCategory?.position;
        } else {
          const prevQuestion = getQuestionByKey(prevQkey)
          const curQuestion = getQuestionByKey(curQkey)
          const DobAgePosition = 11
          return (prevQuestion?.position || DobAgePosition) - (curQuestion?.position || DobAgePosition)
        }
      })
      .reduce((prev, cur) => {

        prev[cur] = ans[cur];
        return prev;
      }, {});
  };

  const getAnswerAdditionalPerson = (newAnswer = answers) => {
    const val = getDynamicAnswerValue(newAnswer, QUESTIONS_KEY.ADDITIONAL_PERSON);
    return val && ADDITIONAL_PERSON_CATEGORY[val];
  };

  const getRecipientByCategory = (cate: API.Category) => {
    let cateRecipient = DEFAULT_CATEGORY_RECIPIENTS;
    const isCare2ND = cate?.name?.includes('(2)') || false;
    if (isCare2ND) {
      cateRecipient = getAnswerAdditionalPerson() || DEFAULT_CATEGORY_RECIPIENTS;
    }
    return cateRecipient;
  };

  const isFullCare = getAnswerAdditionalPerson() == 'full_care_2nd_recipient';

  const isCare2nd = SECONDARY_CARE.includes(getAnswerAdditionalPerson());

  useEffect(() => {
    recipient.current = getRecipientByCategory(category);
  }, [category]);

  useEffect(() => {
    minCurrentIndex.current = groupQuestionsMinIndex(current);
    maxCurrentIndex.current = groupQuestionsMaxIndex(current);
  }, [current, categoryQuestions]);

  const validSection = (index: number) => {
    let idx = index;
    const categoryNext = categories[idx - 1];
    const recip = getRecipientByCategory(categoryNext);
    const totalQuestionRequired = getCategoryQuestions(categoryNext.id).filter((q) => q.required);
    if (isCommonApp) {
      const dataQuestionLastCommonApp = client?.appType === COMMONAPP_VA ? DATA_QUESTION_LAST_COMMONAPP_VA : DATA_QUESTION_LAST_COMMONAPP;
      if (dataQuestionLastCommonApp[categoryNext?.key]) {
        return Object.keys(answers).some((ak) => {
          const { qKey, qCategoryKey } = convertAnswerKey(ak);
          return qCategoryKey === categoryNext?.key && dataQuestionLastCommonApp[qCategoryKey].includes(qKey);
        });
      }
    }
    if (DATA_QUESTION_LAST[categoryNext?.key]) {
      return Object.keys(answers).some((ak) => {
        const { qKey, qCategoryKey } = convertAnswerKey(ak);
        return qCategoryKey === categoryNext?.key && DATA_QUESTION_LAST[qCategoryKey].includes(qKey);
      });

    }

    return Boolean(
      answers[
      `${recip}/${categoryNext?.key}/${totalQuestionRequired[totalQuestionRequired.length - 1]?.key
      }`
      ],
    );
  };
  const onBackByQuestionKey = (question: API.Question, isShowSecondary: boolean) => {
    focusQuestionKey.current = question.key
    let categoriesArray = categories.filter((cate) => question?.categories?.includes(cate.id))
    let cate = categoriesArray[0]
    if (isShowSecondary) {
      recipient.current = isFullCare ? ADDITIONAL_PERSON_CATEGORY['3'] : ADDITIONAL_PERSON_CATEGORY['2']
      cate = categoriesArray[1]
      setCategory(categoriesArray[1])
    } else {
      recipient.current = ADDITIONAL_PERSON_CATEGORY['1'];
      setCategory(categoriesArray[0])
    }
    const cateQuestions = questions.filter(
      (q) =>
        (q.category == cate?.id ||
          q.categories?.includes(cate?.id || '')) &&
        q.name != 'Other',
    )
    const getKey = (questionKey: string) => {
      let key = question.key
      if (questionKey == QUESTIONS_KEY.RELATIONSHIP && isFullCare && isShowSecondary) {
        return questionKey;
      }

      const backKeyQuestion = generation === GENERATION_V3 ? DATA_BACK_ON_QUESTION_KEY_VERSION_3[question.key] : isCommonApp ? DATA_BACK_ON_QUESTION_KEY_COMMONAPP[question.key] : DATA_BACK_ON_QUESTION_KEY[question.key];
      if (backKeyQuestion && typeof backKeyQuestion == "string") {
        key = backKeyQuestion;
      }
      if (backKeyQuestion && typeof backKeyQuestion == "object") {
        const backKeyObject = backKeyQuestion.find((item: { condition: any; }) => {
          const { condition } = item;
          const keyAnswer = Object.keys(condition)[0]
          if (answers[`${recipient.current}/${cate?.key}/${keyAnswer}`] == condition[keyAnswer]) return true;
          return false;

        });
        if (backKeyObject) {
          key = backKeyObject.key
        }
      }
      return key
    };
    const index = cateQuestions.findIndex(
      (q) => q?.key == getKey(question.key),
    );
    setCurrent(index == -1 ? 0 : index);
  }
  const getAnswerByKeyQuestion = (qKey: string) => {
    const question = getQuestionByKey(qKey);
    const categoriesArray = categories.filter((cate) => question?.categories?.includes(cate.id));
    let cate = categoriesArray[0]

    if (recipient.current !== ADDITIONAL_PERSON_CATEGORY['1']) {
      cate = categoriesArray[1]
    }

    return {
      question: question,
      answer: answers[`${recipient.current}/${cate?.key}/${qKey}`],
      questionKey: `${recipient.current}/${cate?.key}/${qKey}`
    }
  }
  return {
    questions,
    setQuestions,
    fetchQuestions,
    loading,
    setCurrent,
    currentQuestions,
    categoryQuestions,
    onNextQuestion,
    onBackQuestion,
    getQuestionByKey,
    getQuestionById,
    isLastQuestionOfCategory,
    current,
    categories,
    setCategories,
    fetchCategories,
    currentCategory: category,
    setCategory,
    nextCategory,
    onChangeCategory,
    minCurrentIndex,
    maxCurrentIndex,
    recipient,
    getAnswerAdditionalPerson,
    isFullCare,
    isCare2nd,
    mainQuestion,
    setMainQuestion,
    answers,
    setAnswers,
    convertAnswer,
    filterAnswers,
    sortAnswers,
    convertAnswerKey,

    getTotalProgess,
    getCurrentProgess,
    currentProgess,
    totalProgess,

    questionRef,
    validSection,
    onBackByQuestionKey,
    isUpdateReview,
    setIsUpdateReview,
    focusQuestionKey,
    IadlServices,
    addAnswerTo2ndPerson,
    getAnswerByKeyQuestion,
    isFillyourSeft,
    careRecipientName,
    autoCheckServices,
    setAutoCheckServices,
    objectState, 
    setObjectState,
    priorAnswers,
    reloadForm,
    reloadKey,
  };
}
